import PropTypes from 'prop-types';

export const ProfileType = PropTypes.shape({
    id: PropTypes.number,
});



// WEBPACK FOOTER //
// ./src/types/profile.js